import Vue from "vue";  

export default {

    async viewRun(viewName = "", page = 1, params = []){
        return await Vue.prototype.$http.post('/View/run', { params: params, viewName: viewName, page: page, limit: 3000000 });
    },

    async viewSearch(field, value){
        return await Vue.prototype.$http.get('/View/search-fields', { 
            params: {
                fields: field, 
                search: value
            }
        })
    }

}